'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = exports.DialogFooter = exports.DialogButton = exports.DialogContent = exports.DialogTitle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dialog title.
 */
var DialogTitle = exports.DialogTitle = function DialogTitle(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('DialogTitle', className) },
    children
  );
};

DialogTitle.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

/**
 * Dialog content.
 */
var DialogContent = function DialogContent(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      other = (0, _objectWithoutProperties3.default)(_ref2, ['children', 'className']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)('DialogContent', className) }, other),
    children
  );
};

exports.DialogContent = DialogContent;
DialogContent.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

/**
 * Dialog button.
 */
var DialogButton = function DialogButton(_ref3) {
  var primary = _ref3.primary,
      danger = _ref3.danger,
      children = _ref3.children,
      className = _ref3.className,
      other = (0, _objectWithoutProperties3.default)(_ref3, ['primary', 'danger', 'children', 'className']);
  return _react2.default.createElement(
    'button',
    (0, _extends3.default)({ className: (0, _classnames2.default)('DialogButton', { primary: primary, danger: danger }, className) }, other),
    children
  );
};

exports.DialogButton = DialogButton;
DialogButton.propTypes = {
  children: _propTypes2.default.node,
  primary: _propTypes2.default.bool,
  danger: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

/**
 * Dialog footer. Used to place buttons in.
 * Stuff is aligned to the right using flexbox.
 */
var DialogFooter = exports.DialogFooter = function DialogFooter(_ref4) {
  var children = _ref4.children,
      className = _ref4.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('DialogFooter', className) },
    children
  );
};

DialogFooter.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

/**
 * Dialog.
 */
var Dialog = exports.Dialog = function Dialog(_ref5) {
  var children = _ref5.children,
      className = _ref5.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('Dialog', className) },
    children
  );
};

Dialog.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Dialog/index.js
// module id = 152
// module chunks = 0